import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withStorageSync } from './storege-sync.feature';
import { HistoryBook } from '../+models/history-book.model';


type HistoryBookState = {
  history: Record<string, HistoryBook[]>;
  currentProjectId: string | null;
};

const initialState: HistoryBookState = {
  history: {},
  currentProjectId: null,
};

export const HISTORY_BOOK_STORE = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withStorageSync({
    key: 'historyState',
    storage: () => localStorage,
}),
  withMethods((store) => ({
    clearStore() {
      patchState(store, initialState);
      store.clearStorage();
    },
    clearHistory() {
      const currentProjectId = store.currentProjectId();
      if (!currentProjectId) return;

      const updatedHistory = { ...store.history() };
      delete updatedHistory[currentProjectId];

      patchState(store, { history: updatedHistory });
    },
    addHistory(entry: HistoryBook, projectId: string) {
      const currentHistory = store.history();
      const projectHistory = currentHistory[projectId] || [];

      patchState(store, {
        history: {
          ...currentHistory,
          [projectId]: [...projectHistory, entry],
        },
      });
    },
    getHistory(): Record<string, HistoryBook[]> {
      return store.history();
    },
    updateHistory(updatedHistory: Record<string, HistoryBook[]>) {
      patchState(store, { history: updatedHistory });
    },
    setCurrentProjectId(projectId: string) {
      patchState(store, { currentProjectId: projectId });
    },
    getCurrentProjectId(): string | null {
      return store.currentProjectId();
    },
  }))
);
